import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "d-flex align-items-center gap-2" }
const _hoisted_3 = { class: "assistant-title text-muted" }
const _hoisted_4 = { class: "d-flex align-items-center gap-2" }
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "card-body assistant-body" }
const _hoisted_8 = {
  key: 0,
  class: "history"
}
const _hoisted_9 = { class: "bubble" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["onClick", "title"]
const _hoisted_12 = {
  key: 1,
  class: "chat-list d-flex flex-column flex-grow-1"
}
const _hoisted_13 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_14 = { class: "d-flex align-items-center gap-2" }
const _hoisted_15 = { class: "fw-bold" }
const _hoisted_16 = { class: "list-container flex-grow-1" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "chat-title" }
const _hoisted_19 = { class: "chat-time text-muted" }
const _hoisted_20 = { class: "input-area d-flex gap-2 align-items-center" }
const _hoisted_21 = ["title"]
const _hoisted_22 = ["disabled", "placeholder"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 1,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_26 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.hasAssistantAccess)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["assistant-widget", { open: _ctx.open }])
      }, [
        _createElementVNode("button", {
          class: "assistant-toggle",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
          title: _ctx.open ? _ctx.$t('panel.assistant.hide') : _ctx.$t('panel.assistant.title')
        }, [...(_cache[11] || (_cache[11] = [
          _createElementVNode("i", { class: "fa fa-magic" }, null, -1)
        ]))], 8, _hoisted_1),
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "assistant-panel card bg-dark text-light shadow",
              style: _normalizeStyle(_ctx.panelStyle),
              onMousedown: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", {
                class: "assistant-header p-1 d-flex justify-content-between align-items-center border-bottom border-secondary",
                onMousedown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.startDrag && _ctx.startDrag(...args)))
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fa fa-lightbulb text-primary" }, null, -1)),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('panel.assistant.title')), 1)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("small", _hoisted_5, _toDisplayString(_ctx.modelName), 1),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-secondary assistant-close-btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open = false)),
                    title: _ctx.$t('panel.assistant.close')
                  }, [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                  ]))], 8, _hoisted_6)
                ])
              ], 32),
              _createElementVNode("div", _hoisted_7, [
                (!_ctx.showChatList)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history, (h, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: idx,
                          class: _normalizeClass(['entry', h.role])
                        }, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", {
                              innerHTML: h.html || _ctx.format(h.text)
                            }, null, 8, _hoisted_10),
                            (h.role==='assistant')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn btn-sm btn-outline-secondary copy-btn",
                                  onClick: ($event: any) => (_ctx.copy(h.text)),
                                  title: _ctx.$t('panel.assistant.copy')
                                }, [...(_cache[14] || (_cache[14] = [
                                  _createElementVNode("i", { class: "fa fa-copy" }, null, -1)
                                ]))], 8, _hoisted_11))
                              : _createCommentVNode("", true)
                          ])
                        ], 2))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-outline-secondary",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleChatList && _ctx.toggleChatList(...args)))
                          }, [...(_cache[15] || (_cache[15] = [
                            _createElementVNode("i", { class: "fa fa-arrow-left" }, null, -1)
                          ]))]),
                          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('panel.assistant.conversations')), 1)
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-outline-secondary",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.createChat && _ctx.createChat(...args)))
                        }, [
                          _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fa fa-plus me-1" }, null, -1)),
                          _createTextVNode(_toDisplayString(_ctx.$t('panel.assistant.newChat')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chats, (c) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: c.id,
                            class: "w-100 text-start chat-list-item",
                            onClick: ($event: any) => (_ctx.openChat(c))
                          }, [
                            _createElementVNode("div", _hoisted_18, _toDisplayString(c.title || _ctx.$t('panel.assistant.chat')), 1),
                            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.formatTime(c.updatedAt)), 1)
                          ], 8, _hoisted_17))
                        }), 128))
                      ])
                    ])),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-secondary",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleChatList && _ctx.toggleChatList(...args))),
                    title: _ctx.showChatList ? _ctx.$t('panel.assistant.closeList') : _ctx.$t('panel.assistant.viewChats')
                  }, [...(_cache[17] || (_cache[17] = [
                    _createElementVNode("i", { class: "fa fa-comments" }, null, -1)
                  ]))], 8, _hoisted_21),
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control form-control-sm bg-secondary text-light",
                    disabled: _ctx.showChatList,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.message) = $event)),
                    onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["exact","prevent"]), ["enter"])),
                    placeholder: _ctx.$t('panel.assistant.placeholder')
                  }, null, 40, _hoisted_22), [
                    [_vModelText, _ctx.message]
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-primary",
                    disabled: _ctx.loading || !_ctx.message.trim() || _ctx.showChatList,
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, [...(_cache[18] || (_cache[18] = [
                          _createElementVNode("i", { class: "fa fa-paper-plane" }, null, -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_25))
                  ], 8, _hoisted_23)
                ])
              ]),
              _createElementVNode("div", {
                class: "resize-handle",
                onMousedown: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.startResize && _ctx.startResize(...args)), ["prevent"])),
                title: _ctx.$t('panel.assistant.resize')
              }, null, 40, _hoisted_26)
            ], 36))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}